import { useMutation } from '@tanstack/react-query';
import {
  sendOneTimePassword,
  SendOneTimePasswordParameters,
  verifyOneTimePassword,
  VerifyOneTimePasswordParameters,
  VerifyOneTimePasswordResult,
} from 'src/api/authAPI';
import ApiError from 'src/api/errorHandling/ApiError';

export function useSendOneTimePassword(onSuccess: () => void) {
  return useMutation<void, ApiError, SendOneTimePasswordParameters>({
    mutationFn: sendOneTimePassword,
    onSuccess,
  });
}

export function useVerifyOneTimePassword(onSuccess: (data: VerifyOneTimePasswordResult) => void) {
  return useMutation<VerifyOneTimePasswordResult, ApiError, VerifyOneTimePasswordParameters>({
    mutationFn: verifyOneTimePassword,
    onSuccess,
  });
}
